import React from 'react';
import { Instagram, Linkedin, Mail, MapPin } from 'lucide-react';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_solar-minimal-clean/artifacts/19o67k2a_IMG_6800.jpeg';

export default function Footer() {
  return (
    <footer className="bg-[#0f1620] text-white pt-16 pb-10">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-5">
              <div className="relative w-12 h-12 rounded-xl overflow-hidden bg-white flex items-center justify-center">
                <img src={LOGO_URL} alt="B-WEB" className="w-[88%] h-[88%] object-contain" />
              </div>
              <div className="leading-tight">
                <div className="font-display text-[22px] font-extrabold tracking-tight">B-WEB</div>
                <div className="text-[10px] tracking-[0.2em] uppercase font-semibold text-white/50">Studio Biella Web</div>
              </div>
            </div>
            <p className="text-[15px] leading-relaxed text-white/60 max-w-md">
              Ciao! Sono uno studente di Biella con la passione per il digitale.
              Non sono un'agenzia e non cerco di diventarlo: nel tempo libero aiuto piccole
              realt&agrave; locali, professionisti o amici a sbarcare online usando
              l'intelligenza artificiale.
            </p>
            <p className="mt-3 text-[15px] leading-relaxed text-white/60 max-w-md">
              Perch&eacute; lo faccio? Mi piace creare, imparare e rendere il web accessibile a
              tutti. &Egrave; un hobby che coltivo con cura, non il mio lavoro principale.
            </p>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[12px] tracking-[0.2em] uppercase font-semibold text-white/40 mb-4">Sito</h4>
            <ul className="space-y-2.5 text-[14px] text-white/80">
              <li><a href="#come-funziona" className="hover:text-[#5eb0e8] transition-colors">Come funziona</a></li>
              <li><a href="#servizi" className="hover:text-[#5eb0e8] transition-colors">Servizi</a></li>
              <li><a href="#perche-noi" className="hover:text-[#5eb0e8] transition-colors">Perché noi</a></li>
              <li><a href="#contatti" className="hover:text-[#5eb0e8] transition-colors">Contatti</a></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-[12px] tracking-[0.2em] uppercase font-semibold text-white/40 mb-4">Legale</h4>
            <ul className="space-y-2.5 text-[14px] text-white/80">
              <li><a href="#" className="hover:text-[#5eb0e8] transition-colors">Privacy Policy</a></li>
              <li><a href="#" className="hover:text-[#5eb0e8] transition-colors">Cookie Policy</a></li>
              <li><a href="#" className="hover:text-[#5eb0e8] transition-colors">Preferenze cookie</a></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[12px] tracking-[0.2em] uppercase font-semibold text-white/40 mb-4">Contatti</h4>
            <ul className="space-y-2.5 text-[14px] text-white/80">
              <li>
                <a
                  href="https://wa.me/393383463712"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 hover:text-[#5eb0e8] transition-colors"
                >
                  <Mail className="w-4 h-4 flex-shrink-0" /> WhatsApp diretto
                </a>
              </li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 flex-shrink-0" /> +39 338 346 3712</li>
              <li className="flex items-center gap-2"><MapPin className="w-4 h-4 flex-shrink-0" /> Biella, Piemonte</li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="https://www.instagram.com/biella_web"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#1e6cb0] border border-white/10 flex items-center justify-center transition-colors"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a href="#" className="w-9 h-9 rounded-full bg-white/5 hover:bg-[#1e6cb0] border border-white/10 flex items-center justify-center transition-colors">
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-[13px] text-white/50">
          <span>&copy; {new Date().getFullYear()} B-WEB Studio Web Biella. Tutti i diritti riservati.</span>
          <span>Made with care &middot; Studio web full-service</span>
        </div>
      </div>
    </footer>
  );
}
